import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '@/product/context/auth/authContext'
import ProductContext from '@/product/context/product/productContext'
import CommonContext from '@/product/context/common/commonContext'
import { Button } from '@material-ui/core'
import { TvTwoTone } from '@material-ui/icons'

const SavedSearch = (props) => {
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated, saveSearch } = authContext
    const productContext = useContext(ProductContext)
    const commonContext = useContext(CommonContext)
    const { setSearchValue, searchValue, clearSearchValue } = commonContext

    const { search_allproducts, getAllSearchProducts, responseStatus, addSavedSearch } =
        productContext
    const [savedSearchOn, setSavedSearchOn] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [viewProduct, setViewProduct] = useState([])
    const [savedSearchTemp, setSavedSearchTemp] = useState('')
    const formikSearch = props.formikSearch

    const addSavedSearcData = (search_text) => {
        addSavedSearch({ search_text })
    }
    console.log(formikSearch.values, 'saved')

    useEffect(() => {
        if (searchValue) {
            const searchFilter = searchValue.filters
            Object.keys(searchFilter).forEach((key) => {
                if (
                    searchFilter[`${key}`].type === 'array' ||
                    searchFilter[`${key}`].type === 'findinarray'
                ) {
                    let value = searchFilter[`${key}`].value
                    formikSearch.setFieldValue(`filters.${key}.value`, [value.toString()])
                } else {
                    let value = searchFilter[`${key}`].value
                    formikSearch.setFieldValue(`filters.${key}.value`, value.toString())
                }
            })

            clearSearchValue()
        }
    }, [searchValue])
    useEffect(() => {
        setIsLoading(false)
        setViewProduct(search_allproducts.records.length > 0 ? search_allproducts.records : [])
        props.getSearch ? props.getSearch(search_allproducts.records) : []
    }, [search_allproducts])
    useEffect(() => {
        setIsLoading(true)
        if (!searchValue) {
            if (
                !formikSearch.values.filters.searchbar.value ||
                formikSearch.values.filters.searchbar.value == ''
            )
                formikSearch.setFieldValue(`filters.searchbar.value`, savedSearchTemp)
            getAllSearchProducts(formikSearch.values, 'liveProducts')
        } else {
            //getAllSearchProducts(search)
        }
    }, [formikSearch.values])
    useEffect(() => {
        if (searchValue?.filters?.searchbar?.value) {
            formikSearch.setFieldValue(
                `filters.searchbar.value`,
                searchValue.filters.searchbar.value,
            )
            setSavedSearchTemp(searchValue.filters.searchbar.value)
            setSavedSearchOn(true)
        }
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    return (
        <>
            {isAuthenticated &&
                props.isvisible &&
                (formikSearch.values?.filters?.searchbar?.value || savedSearchOn) && (
                    <>
                        <h4>
                            {'You have searched for'}
                            <span>
                                &quot;
                                {formikSearch.values.filters.searchbar.value || savedSearchTemp}
                                &quot;
                            </span>
                        </h4>
                        <Button
                            id="search_bookmark"
                            onClick={() =>
                                addSavedSearcData(
                                    formikSearch.values.filters.searchbar.value || savedSearchTemp,
                                )
                            }
                        >
                            <span className="material-icons">bookmark_add</span>
                            {/* REPLACE THE FOLLOWING ICON THE ONCE SEARCH HAS BEEN SAVED */}
                            {/* <span className="material-icons">bookmark_added</span> */}
                            {'Save this search'}
                        </Button>
                    </>
                )}
        </>
    )
}
export default SavedSearch
